import PropTypes from 'prop-types';

const OptionPropType = (props, propName, componentName) => {
  const prop = props[propName];
  let error;
  if (!prop.hasOwnProperty('label') || typeof prop.label !== 'string') {
    error = new Error(
      `An option provided to ${componentName} must have a "label"  key with associated value of "string" type`
    );
  }

  if (!prop.hasOwnProperty('value') || typeof prop.value !== 'string') {
    error = new Error(
      `An option provided to ${componentName} must have a "value" key with associated value of "string" type`
    );
  }

  if (prop.hasOwnProperty('disabled') && typeof prop.value !== 'boolean') {
    error = new Error(
      `An option provided to ${componentName} with the optional "disabled" key must have a value of "boolean" type`
    );
  }

  return error;
};

const OptionGroupPropType = PropTypes.shape({
  label: PropTypes.string,
  options: PropTypes.arrayOf(OptionPropType),
});

export const OptionsPropType = PropTypes.oneOfType([
  PropTypes.arrayOf(OptionPropType),
  PropTypes.objectOf(OptionGroupPropType),
]);



// WEBPACK FOOTER //
// ./src/__utils/selectPropTypes.js